import middle from './middle.tpl';
import '~/style/middle.less';


export default function MiddleTpl() {
    const data = {
        phone: '952555',
        apptxt: '手机扫码 下载理财',
        end_tit: '买基金就上同花顺爱基金',
        end_desc: '平台累计服务用户超500万',
        end_ul: [
            { name: '安全可靠', tit: '证监会核准资质', desc: '数千万用户选择', img: require('../../images/surf.png') },
            { name: '产品齐全', tit: '超5000多只基金', desc: 'A股海外市场轻松投', img: require('../../images/product.png') },
            { name: '费率优惠', tit: '费率全面1折起', desc: '理财更省心省钱', img: require('../../images/cheap.png') },
            { name: '服务周到', tit: '7*24小时交易', desc: '投资疑问及时解答', img: require('../../images/service.png') }
        ],
        img: [
            require('../../images/nav-tit.png'),
            require('../../images/nav-desc.png'),
            require('../../images/banner.png'),
            require('../../images/test_er.png'),
            require('../../images/btn-ios.png'),
            require('../../images/btn-android.png'),
            require('../../images/module1.png'),
            require('../../images/module2.png'),
            require('../../images/module3.png'),
            require('../../images/er.png'),
            require('../../images/di.png')
        ]
    };
    return {
        middle: middle(data)
    };
}